import { GenderType, ScoreType } from '../../../../models';

const displayedScoreTypes = [
  ScoreType.D,
  ScoreType.D1,
  ScoreType.D2,
  ScoreType.E,
  ScoreType.E1,
  ScoreType.E2,
  ScoreType.E3,
  ScoreType.E4,
  ScoreType.E5,
  ScoreType.E6,
];

export function getJudgeDisplayContext(
  stageJudge,
  gender,
  parentheses = true,
  abbreviated = false
) {
  let result = '';

  if (!stageJudge || Object.keys(stageJudge).length === 0) {
    return result;
  }

  if (gender === GenderType.FEMALE) {
    const judge = stageJudge.sessionJudgeAssignment?.judge;
    if (judge?.womensBrevet) {
      result = abbreviated ? 'B' : 'Brevet';
    } else if (judge?.womensNational) {
      result = abbreviated ? 'N' : 'National';
    } else if (judge?.womensLevel10) {
      result = abbreviated ? 'L10' : 'Level 10';
    }
  } else {
    result =
      (stageJudge?.scoreTypes &&
        `${stageJudge.scoreTypes
          .filter((scoreType) => displayedScoreTypes.indexOf(scoreType) !== -1)
          .join(', ')}`) ||
      '';
  }

  if (result !== '' && parentheses) {
    result = `(${result})`;
  }

  return result;
}
